// Display data for the vehicle classes. IDs MUST match backend server.py.
// Images are customer-provided black fleet vehicles.
const IMG = {
  octavia: "/images/veh_octavia.webp",
  eclass: "/images/veh_eclass.webp",
  sclass: "/images/veh_sclass.webp",
  vito: "/images/veh_vito.webp",
  sprinter: "/images/veh_sprinter.webp",
};

export const PER_KM = 2.2;

export const VEHICLES = [
  { id: "economy", name: "Economy", models: "Škoda Octavia", orSimilar: true, pax: 3, bags: 3, base: 70, perKm: 2.2, image: IMG.octavia },
  { id: "economy_xl", name: "Economy XL", models: "VW Transporter", orSimilar: true, pax: 6, bags: 6, base: 80, perKm: 3.0, image: "/images/veh_economyxl.webp" },
  { id: "business", name: "Business Class", models: "Mercedes E-Klasse", orSimilar: true, pax: 3, bags: 3, base: 90, perKm: 3.4, image: IMG.eclass },
  { id: "first", name: "First Class", models: "Mercedes S-Klasse", orSimilar: true, pax: 3, bags: 2, base: 120, perKm: 5.0, image: IMG.sclass },
  { id: "standard_van", name: "Standard Van", models: "Mercedes Vito", pax: 7, bags: 7, base: 90, perKm: 3.4, image: IMG.vito },
  { id: "premium_van", name: "Premium Van", models: "Mercedes V-Klasse XXL", pax: 6, bags: 6, base: 100, perKm: 3.8, image: "/images/veh_premiumvan.webp" },
  { id: "sprinter", name: "Sprinter", models: "Mercedes Sprinter", pax: 16, bags: 16, base: 180, perKm: 6.8, image: IMG.sprinter },
];

// Localized helper: appends the translated "or similar" suffix to the model
// string for the classes that use a representative model (was hardcoded "o. ä.").
export const vehicleModels = (v, t) =>
  v && v.orSimilar ? `${v.models} ${t ? t("veh_or_similar") : "o. ä."}` : (v ? v.models : "");

export const VEHICLE_IMG = Object.fromEntries(VEHICLES.map((v) => [v.id, v.image]));
